var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgVCirclePurple = function SvgVCirclePurple(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#A897F4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.756.172C3.928.172 0 4.1 0 8.93c0 4.828 3.928 8.756 8.756 8.756s8.756-3.928 8.756-8.756c0-4.829-3.928-8.757-8.756-8.757z",
    transform: "translate(-298.000000, -451.000000) translate(298.000000, 451.000000)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5743AF",
    d: "M11.547 6.136l-4.086 4.088-1.497-1.496c-.275-.275-.722-.275-.996 0-.276.276-.276.723 0 .997l1.994 1.996c.138.137.317.206.499.206.18 0 .36-.07.499-.206l4.585-4.587c.276-.276.276-.722 0-.998-.275-.275-.722-.275-.998 0z",
    transform: "translate(-298.000000, -451.000000) translate(298.000000, 451.000000)"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVCirclePurple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/V_circle_purple.7a834f13.svg";
export { ForwardRef as ReactComponent };